<template>
  <div class="space-y-6 animate-pulse mt-4">
    <div v-for="i in 3" :key="i" class="flex flex-col space-y-3 p-4 bg-zinc-900/50 rounded-lg">
      <div class="flex items-center space-x-3">
        <div class="h-10 w-10 bg-zinc-800 rounded-full"></div>
        <div class="space-y-2">
          <div class="h-4 w-32 bg-zinc-800 rounded"></div>
          <div class="h-3 w-20 bg-zinc-800 rounded"></div>
        </div>
      </div>
      <div class="space-y-2 pt-2">
        <div class="h-3 w-full bg-zinc-800 rounded"></div>
        <div class="h-3 w-3/4 bg-zinc-800 rounded"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
